import { FilterTag, FrontendFilterTag } from "types/types";

type TreeItem<T> = T & { children: TreeItem<T>[] };

export default function buildTree<T>(
  array: T[],
  elementKey: keyof T,
  parentKey: keyof T
): TreeItem<T>[] {
  let tree = [] as TreeItem<T>[];
  for (let i = 0; i < array.length; i++) {
    if (array[i][parentKey]) {
      let parent = array
        .filter((elem) => elem[elementKey] === array[i][parentKey])
        .pop() as TreeItem<T>;
      if (!parent["children"]) {
        parent.children = [];
      }
      parent.children.push(array[i] as TreeItem<T>);
    } else {
      tree.push(array[i] as TreeItem<T>);
    }
  }
  return tree;
}

export function makeTree(tags: FilterTag[]) {
  const base: FrontendFilterTag = {
    children: [],
    completeKey: "",
    id: 0,
    key: "",
    name: "",
  };

  for (const tag of tags) {
    const path = tag.completeKey.split(".");

    let curr = base;

    path.forEach((e, i) => {
      const currPath = path.slice(0, i + 1).join(".");
      const child = curr.children.find((e) => e.completeKey === currPath);

      if (child) {
        curr = child;
      } else {
        curr.children.push({
          id: tag.id,
          key: tag.key,
          name: tag.name,
          parentId: tag.parentId,
          completeKey: currPath,
          children: [],
        });
        curr = curr.children[curr.children.length - 1];
      }
    });
  }

  return base.children;
}
